<template>
    <div id="main-wrapper" class="section">
        <div class="container" role="main">
            <div class="flex-row row column-content-wrapper">
                <div id="content" class="col-12 article-container">
                    <article
                        id="page-150"
                        class="post-150 page type-page status-publish czr-hentry"
                    >
                        <header class="entry-header">
                            <div class="entry-header-inner">
                                <h1 class="entry-title"></h1>
                            </div>
                        </header>
                        <div class="post-entry tc-content-inner">
                            <section class="post-content entry-content">
                                <div class="czr-wp-the-content">
                                    <div class="row">
                                        <div class="col-sm-12 col-lg-6">
                                            <p></p>
                                            <p style="text-align:center" class="has-huge-font-size">
                                                <strong>Get Our App</strong>
                                            </p>
                                            <p style="text-align:center">
                                                Do you have trouble finding a house or business due to a lack of street names or maps?  Do you struggle when using GPS coordinates (-33.926689, 18.418764)?  Then try our App, it was built to solve these problems.
                                            </p>
                                            <p style="text-align:center">
                                                <b>Download for FREE</b><br/>
                                                Our app is now available on the Google play &amp; Apple stores
                                            </p>
                                            <!-- <p
                                                style="text-align:center"
                                            >Download for FREE &#8211; our app is available on the Google play store</p> -->


                                            <div class="row">
                                                <div class="col-sm-6">
                                                    <figure class="aligncenter">
                                                        <a
                                                            href="https://play.google.com/store/apps/details?id=com.kionier.geoapp"
                                                            target="_blank"
                                                            rel="noreferrer noopener"
                                                        >
                                                            <img
                                                                src="/images/google-play.png"
                                                                alt
                                                                class="wp-image-59"
                                                            />
                                                        </a>
                                                    </figure>
                                                </div>
                                                <div class="col-sm-6">
                                                    <figure class="aligncenter">
                                                        <a
                                                            href="https://apps.apple.com/za/app/id1514468431"
                                                            target="_blank"
                                                            rel="noreferrer noopener"
                                                        >
                                                            <img
                                                                src="/images/apple-store.png"
                                                                alt
                                                                class="wp-image-59"
                                                            />
                                                        </a>
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-lg-6">
                                            <div class="wp-block-image">
                                                <figure class="aligncenter is-resized">
                                                    <img
                                                        src="/images/Mobile_SA-580x1024.png"
                                                        alt
                                                        class="wp-image-85"
                                                        width="290"
                                                        height="512"
                                                        srcset="/images/Mobile_SA-580x1024.png 580w, /images/Mobile_SA-170x300.png 170w, /images/Mobile_SA.png 583w"
                                                        sizes="(max-width: 290px) 100vw, 290px"
                                                    />
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <footer class="post-footer clearfix"></footer>
                            </section>
                            <!-- .entry-content -->
                        </div>
                        <!-- .post-entry -->
                    </article>
                </div>
            </div>
            <!-- .column-content-wrapper -->
        </div>
        <!-- .container -->

        <div id="czr-push-footer"></div>
    </div>
    <!-- #main-wrapper -->
</template>

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

<script>
export default {
    metaInfo () {
        return {
            title: "Our App | Wersa",
            link: [
                { rel: 'canonical', href: 'https://wersa.co.za/app' }
            ]
        };
    }
};
</script>